import { Component, Input, OnInit } from "@angular/core";
import { DateTime, Interval } from "luxon";
import { WidgetsService } from "src/app/shared/services/widgets.service";

@Component({
  selector: 'widget-admin-review',
  templateUrl: './widget-admin-review.component.html',
  styleUrls: ['./widget-admin-review.component.scss']
})
export class WidgetAdminReviewComponent implements OnInit {
  @Input() widgetConfig;

  stageId = null;
  stageName = '';
  timeLeftToStart = 0;
  timeLeftString = 'Days';
  isDeadlinePassed = false;
  isEliminated = false;
  isValid = null;
  loading = false;

  
  constructor(private widgetsService: WidgetsService) { }

  ngOnInit() {
    this.init()
  }

  async init() {
    this.loading = true;
    this.stageId = this.widgetConfig?.widgetSettings?.stageId
    if (!this.stageId) return
    const res: any = await this.widgetsService.getAdminReviewWidgetData(this.stageId).toPromise();
    this.stageName = res.stageName;
    this.isEliminated = res.isEliminated;
    this.isValid = res.isValid;
    const currentDate = DateTime.fromJSDate(new Date()).setZone('UTC');
    const stageStartDate = DateTime.fromISO(res.stageStartDate);
    this.isDeadlinePassed = res.stageEndDate < DateTime.fromJSDate(new Date()).setZone("UTC").toISO();
    this.timeLeftToStart = Interval.fromDateTimes(currentDate, stageStartDate).length('days') || 0;
    if (this.timeLeftToStart < 2 && this.timeLeftToStart !== 0) {
      this.timeLeftString = 'Day';
    }
    if (this.timeLeftToStart < 1 && this.timeLeftToStart !== 0) {
      this.timeLeftToStart = Interval.fromDateTimes(currentDate, stageStartDate).length('hours') || 0;
      this.timeLeftString = this.timeLeftToStart < 2 ? 'Hour' : 'Hours';
    }
    if (this.timeLeftToStart < 1 && this.timeLeftToStart !== 0) {
      this.timeLeftToStart = Interval.fromDateTimes(currentDate, stageStartDate).length('minutes') || 0;
      this.timeLeftString = this.timeLeftToStart < 2 ? 'Minute' : 'Minutes';
    }
    this.loading = false;
  }

  roundTime(days: number) {
    return Math.round(days)
  }
}
